import React, { Component, PropTypes } from 'react';
import { getDeckList } from '../../services/APIAgent';
import Mediator from '../../services/Mediator';
import { fadein } from '../decorators';
import DeckList from '../decklist';
import DeckEditor from '../deckeditor';
import classnames from 'classnames';
import './mainview.css';

class MainView extends Component {
    constructor(props, ...rest) {
        super(props, ...rest);

        this.state = {
            decks : [],
            deckId: null
        };

        this.onAdd = this.onAdd.bind(this);
		this.refreshDecksList = this.refreshDecksList.bind(this);

        Mediator.add(this);
    }
    componentWillMount() {
        return this.refreshDecksList();
    }
    componentWillUnmount() {
        Mediator.remove(this);
    }
    onAdd() {
        this.setState({ deckId: 'new' });
    }
    onChangeDeckId(deckId) {
        this.setState({ deckId });
    }
    onSelect(deckId) {
        let { deckId: currentDeckId } = this.state;
        if (deckId === currentDeckId) return;

        this.setState({ deckId });
    }
	refreshDecksList() {
		return getDeckList()
		.then(decks => this.setState({ decks }))
        .catch(() => this.setState({ decks: [] }));
	}
    onDeckListRequiresUpdate() {
        this.refreshDecksList();
    }
    render() {
        let { language, visible } = this.props;
        let { deckId } = this.state;

        let classes = classnames({
            'main-view': true,
            visible
        });

        return (<div className={classes}>
            <DeckList {...this.props} {...this.state} onSelect={ id => this.onSelect(id) } onAdd={ this.onAdd } />
            { deckId ? <DeckEditor key={ deckId } deckId={deckId} language={language} /> : <div className="deck-editor"></div> }
        </div>);
    }
}

MainView.propTypes = {
    language: PropTypes.string,
    visible: PropTypes.bool.isRequired
};

export default fadein(MainView);


// WEBPACK FOOTER //
// ./src/components/mainview/index.js